import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { Solution, SolutionResults } from '../digital-solutions/models/solutions.model';

@Injectable({
  providedIn: 'root',
})
export class DigitalSolutionsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiURL;

  private readonly options = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  getSolutions() {
    return this.http.get<SolutionResults>(`${this.apiUrl}solutions/`, this.options);
  }

  getSolutionBySlug(slug: string) {
    return this.http.get<Solution>(`${this.apiUrl}solution-by-slug/${slug}`, this.options);
  }
}
